const $ = require("jquery");

export default function scrollToElement($element) {
    $([document.documentElement, document.body]).animate({
        scrollTop: $element.offset().top - $('.navbar').outerHeight() - 20
    }, 200);
}
